import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames'
import { throttle } from '../utils/Events';
import './Select2.scss';



class Select2 extends Component {

    node: HTMLDivElement;

    static defaultProps = {
        clearButton: false,
        options: [],
        disabled: false,
        isDisabled: false,
        blocked: false,
        name: null,
        multiple: false,
        className: null,
        displayPropertyName: 'label',
        renderDisplayed: null,
        renderOption: null,
        renderPlaceholder: null,
        onChange: null,
        onClose: null,
        closeAfterSelection: true,
        isSelected: null,
        maxWidth: 'none',
        minWidthDropdown: 0,
        maxHeightDropdown: 999,
    }

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            isFocused: false,
            selectedIndex: 0,
            focusedIndex: 0,
        }
    }

    static getDerivedStateFromProps(props, state) {
        // Any time the current user changes,
        // Reset any parts of state that are tied to that user.
        // In this simple example, that's just the email.
        if (props['options'] && !state['isOpen'] && props['isSelected'] === false) {
            return {
                selectedIndex: -1,
                focusedIndex: -1
            };
        } else if (props['options'] && !state['isOpen']) {

            var index = props.options.findIndex(o => o.value === props.value) || 0;


            if (state.focusedIndex !== index) {
                return {
                    selectedIndex: index,
                    focusedIndex: index
                };
            }
        }
        return null;
    }
    handlePositionUpdate = throttle(() => {
        if (this.state.isOpen) {
            this.forceUpdate();
        }
    }, 16);

    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside.bind(this), true);
        window.addEventListener("scroll", this.handlePositionUpdate, true);
        window.addEventListener("resize", this.handlePositionUpdate, true);
    }

    handleClickOutside(e) {
        // console.log( e.target );
        if (this.node) {
            var contains = this.node.contains(e.target) || this.node === e.target;
            var dropdownContains = !!this.dropdown && this.dropdown?.contains(e.target);
            if (contains === false && dropdownContains === false) {
                this.setState({
                    isOpen: false,
                    isFocused: false
                });
            }
        }
    }


    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener("scroll", this.handlePositionUpdate, true);
        window.removeEventListener("resize", this.handlePositionUpdate, true);
    }


    handleClick = (e) => {
        e.preventDefault();

        if (!this.props.disabled && !this.props.isDisabled) {

            var isOpen = !this.state.isOpen;
            if (isOpen && this.inputnode) {
                this.inputnode.focus();
            }
            this.setState({
                selectedIndex: this.state.focusedIndex,
                isOpen: isOpen,
                isFocused: isOpen,
            });
        }
    }

    handleKeyDown = (e) => {
        // if (this.props.onKeyDown) {
        //     this.props.onKeyDown(e);
        // }
        const { selectedIndex, focusedIndex } = this.state;


        if (this.isDisabled()) {
            return false;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                if (!e.shiftKey) {
                    if (!this.state.isOpen || (!isNaN(focusedIndex) && focusedIndex === this.props.options.length - 1)) {
                        var _focusedIndex = focusedIndex;
                    } else if (focusedIndex < this.props.options.length - 1) {
                        var _focusedIndex = focusedIndex + 1;
                    } else {
                        var _focusedIndex = 0;
                    }
                    this.setState({
                        isOpen: true,
                        focusedIndex: _focusedIndex,
                    });
                } else {

                    this.setState({
                        isOpen: false,
                    });
                    if (this.props.onKeyDown) {
                        this.props.onKeyDown(e);
                    }
                }
                console.log('ArrowDown');
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (!e.shiftKey) {
                    console.log('ArrowUp');
                    if (focusedIndex > 0) {
                        this.setState({
                            focusedIndex: focusedIndex - 1
                        })
                    }
                } else {
                    this.setState({
                        isOpen: false,
                    });
                    if (this.props.onKeyDown) {
                        this.props.onKeyDown(e);
                    }
                }
                break;
            case 'Tab':

                this.setState({
                    isOpen: false,
                    isFocused: false
                });
                break;
            case 'Enter':
                e.preventDefault();
                console.log('ArrowUp');
                var option = this.props.options.find((o, index) => index === focusedIndex);
                if (option) {
                    this.handleOptionClick(e, { option: option });
                }
                this.setState({
                    selectedIndex: focusedIndex,
                    isOpen: false,
                    isFocused: true
                });
                break;

            default:
                break;
        }
    }

    handleMouseOver = (e) => {
        if (this.props.onMouseOver) {
            this.props.onMouseOver(e);
        }
    }
    handleMouseOut = (e) => {
        if (this.props.onMouseOut) {
            this.props.onMouseOut(e);
        }
    }
    handleOptionOver = (e, { option, index }) => {

        this.setState({
            focusedIndex: index
        })
    }
    handleOptionOut = (e, { option, index }) => {

    }
    handleFocus = (e) => {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
        var newState = {
            isFocused: true
        };

        if (!this.isDisabled()) {
            if (this.props.openOnFocus) {
                newState.isOpen = true;
            }
        }
        this.setState(newState);

    }
    handleBlur = (e) => {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
        this.setState({
            isFocused: false
        });
    }


    handleOptionClick = (e, { option }) => {
        e.preventDefault();

        if (!option || !option['disabled']) {
            if (this.props.onChange) {
                this.props.onChange(e, option);
            }
            if (this.props.closeAfterSelection) {
                this.close();
            }
        }
    }

    autoScroll = () => {
        if (this.node) {
            const option = this.node.querySelector(`.Select-option--focused,.Select2__option.focused`);
            if (option) {
                var scrollParent = option.closest('.Select2__dropdown');
                if (scrollParent.scrollTop + scrollParent.clientHeight < option.offsetTop + 50) {
                    scrollParent.scrollTop = option.offsetTop - scrollParent.clientHeight + 70;
                } else if (scrollParent.scrollTop > option.offsetTop) {
                    scrollParent.scrollTop = option.offsetTop;
                }
                // console.log({ option });
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {
        this.autoScroll();
    }

    close = () => {
        this.setState({
            isOpen: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    isSelected(val) {
        var value = this.props.value;
        var multiple = this.props.multiple;
        // var options = this.props.options;
        return multiple ? value.includes(val) : val === value;
    }


    renderOptions() {
        const { clearButton, isSelected = null, multiple } = this.props;
        return this.props.options.map((o, index) => {

            var _itemSelected = index === this.state.selectedIndex;
            if (isSelected === false) {
                _itemSelected = false;
            }
            if (multiple && this.isSelected(o.value)) {
                _itemSelected = true;
            }

            if (this.props.components?.Option) {
                return <this.props.components.Option
                    key={index}
                    data={o}
                    innerProps={{
                        onClick: e => this.handleOptionClick(e, { option: o, index: index }),
                        onMouseOver: e => this.handleOptionOver(e, { option: o, index: index }),
                        onMouseOut: e => this.handleOptionOut(e, { option: o, index: index }),
                    }}
                    // onClick={}
                    isFocused={index === this.state.focusedIndex}
                    isDisabled={o.disabled}
                    isSelected={_itemSelected}
                    // innerRef
                    // innerProps
                    selectProps={this.props}
                >
                    <span>
                        {o.label}
                    </span>
                </this.props.components.Option>
            } else {
                return (
                    <div key={o.value} value={o.value}
                        onMouseOver={e => this.handleOptionOver(e, { option: o, index })}
                        onMouseOut={e => this.handleOptionOut(e, { option: o, index })}
                        className={classNames({
                            'Select2__option': true,
                            // 'active': o.value === this.props.value,
                            'active': _itemSelected,
                            'focused': index === this.state.focusedIndex,
                            'disabled': o.disabled,

                        })}>
                        <div onClick={e => this.handleOptionClick(e, { option: o })} className="Select2__option-label">
                            {this.props.renderOption ? this.props.renderOption(o) : o.label}
                        </div>
                        {clearButton && o.value === this.props.value && <button onClick={e => this.handleOptionClick(e, { option: null })} className="Select2__option-button">

                            <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#cross"></use></svg>

                        </button>
                        }
                    </div>
                )
            }
        })
    }

    isDisabled() {
        var {
            disabled = false,
            isDisabled = false } = this.props;
        return Boolean(disabled || isDisabled);
    }

    renderDropdown({ mainClasses }) {
        const { description, footer } = this.props;
        const { isOpen } = this.state;
        const rect = this.node?.getBoundingClientRect() || {};
        if (!rect) {
            return null
        }
        var style = {
            top: rect?.top + rect?.height,
            left: rect?.left,
            width: rect?.width,
            position: 'fixed',
            maxHeight: this.props.maxHeightDropdown,
            minWidth: this.props.minWidthDropdown,
            display: isOpen ? 'block' : 'none',
        };

        if (this.props.dropdownContainer) {
            var container = this.node?.closest(this.props.dropdownContainer);
            if (!container) {
                return null;
            }

            return ReactDOM.createPortal(
                <div ref={el => this.dropdown = el} className={`${mainClasses} mainClasses`} style={{ height: 0, width: 0 }}>
                    <div className="Select2__dropdown shadow-default" style={style}>
                        {
                            description && <div className="Select2__description">{description}</div>
                        }
                        {
                            this.renderOptions()
                        }
                        {
                            footer && <div className="Select2__footer">{footer}</div>
                        }

                    </div>
                </div>,
                container
            )
        }

        return <div className="Select2__dropdown shadow-default" style={{ minWidth: this.props.minWidthDropdown, maxHeight: this.props.maxHeightDropdown }}>
            {
                description && <div className="Select2__description">{description}</div>
            }
            {
                this.renderOptions()
            }
            {
                footer && <div className="Select2__footer">{footer}</div>
            }

        </div>

    }

    render() {
        var {
            value = null,
            multiple = false,
            clearButton,
            disabled = false,
            isDisabled = false,
            blocked,
            options = [],
            className = null,
            name = null,
            description = null,
            footer = null,
            placeholder = null,
            renderDisplayed = null,
            renderPlaceholder = null,
            renderOption = null,
            displayPropertyName } = this.props;

        var isEmpty = multiple ? value.length === 0 : !value;
        var displayed = '';
        // var selected = options.find
        var selected_option = multiple ? options.filter(o => value.includes(o.value)) : options.find(o => o.value === value);

        if (selected_option && typeof renderDisplayed === 'function') {
            displayed = renderDisplayed(selected_option);
        } else if (!isEmpty && selected_option.length > 0 && multiple) {
            displayed = selected_option.length > 1 ? `${selected_option.length} selected` : selected_option[0][displayPropertyName];
        } else if (!isEmpty && selected_option) {
            displayed = selected_option[displayPropertyName];
        }

        if (isEmpty && typeof renderPlaceholder === 'function') {
            placeholder = renderPlaceholder(this.props);
        }


        var isEmptyAndBlocked = isEmpty && blocked;
        if (isEmptyAndBlocked) {
            displayed = '';
            placeholder = '';
        }

        const mainClasses = `Select2 ${className} ` + classNames({
            'Select2': true,
            'Select2--focused': this.state.isFocused,
            'isOpen': this.state.isOpen,
            'isDisabled': this.isDisabled(),
            'isEmpty': isEmpty,
            'isEmptyAndBlocked': isEmptyAndBlocked,
        });
        return (
            <div ref={el => this.node = el} className={mainClasses} style={{ ...this.props.style, maxWidth: this.props.maxWidth }}>
                <div
                    onClick={this.handleClick}
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                    onKeyDown={this.handleKeyDown}

                    className="Select2__input-wrapper">
                    <input ref={el => this.inputnode = el}
                        data-group={this.props['data-group']}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        disabled={this.isDisabled()}
                        className="Select2__hidden-input" type="text" readOnly={true} value={displayed} name={name} />
                    <span disabled={disabled} className={classNames({
                        'Select2__input': true,
                        blocked: blocked,
                    })} type="text" value={displayed} readOnly><span className="truncate">{displayed}</span></span>
                    <span disabled={disabled} className={classNames({
                        'Select2__placeholder': true,
                        blocked: blocked,
                    })} type="text" value={placeholder} readOnly><span className="truncate">{placeholder}</span></span>
                    {/* <input disabled={disabled} className={classNames({
                        'Select2__placeholder': true,
                        blocked: blocked,
                    })} type="text" value={placeholder} readOnly /> */}
                    {
                        !isEmptyAndBlocked &&
                        <span className="Select2__arrow">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7929 7.32499L8.04841 12.0694L3.30396 7.32499L3.93659 6.69235L8.04841 10.8042L12.1602 6.69235L12.7929 7.32499Z" fill="#1F1F1F" />
                            </svg>

                        </span>
                    }
                </div>
                {this.renderDropdown({ mainClasses })}


            </div>
        );
    }
}

export default Select2;
